import { render } from "./DoctoresModal.vue?vue&type=template&id=5f5792ff&scoped=true"
import script from "./DoctoresModal.vue?vue&type=script&lang=js"
export * from "./DoctoresModal.vue?vue&type=script&lang=js"

import "./DoctoresModal.vue?vue&type=style&index=0&id=5f5792ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5792ff"]])

export default __exports__